module.exports = "pegasus/assets/blocks/social-2-tech.png";